import { render, staticRenderFns } from "./air.vue?vue&type=template&id=75c90853&scoped=true&"
import script from "./air.vue?vue&type=script&lang=js&"
export * from "./air.vue?vue&type=script&lang=js&"
import style0 from "./air.vue?vue&type=style&index=0&id=75c90853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c90853",
  null
  
)

export default component.exports